"use client";
import { useState } from "react";

export function useForwardAngle(quarterTurns: number): number {
  const [angle, setAngle] = useState(quarterTurns * 90);
  const [prevQuarter, setPrevQuarter] = useState(quarterTurns);

  if (prevQuarter !== quarterTurns) {
    const delta = (((quarterTurns - prevQuarter) % 4) + 4) % 4;
    setPrevQuarter(quarterTurns);
    setAngle((a) => a + delta * 90);
  }

  return angle;
}
